import React from "react";

export const MainContext = React.createContext({
    user: {},
});